import i18n from '../../i18n'

export default [
  { icon: 'order.png', name: i18n.t('订单查询'), route: 'order', code: 'Order' },
  { icon: 'transport.png', name: i18n.t('物流查询'), route: 'logistics', code: 'OutBoundLogistics' },
  { icon: 'inventory.png', name: i18n.t('库存查询'), route: 'stock', code: 'Stock' },
  { icon: 'customer.png', name: i18n.t('客户查询'), route: 'customer', code: 'SICustomer_DBQuery' },
  { icon: 'urgent-order.png', name: i18n.t('订单加急'), route: 'urgent-order', code: 'GreenChannelUrgentOrder' },
  { icon: 'special-delivery.png', name: i18n.t('特殊发货'), route: 'special-delivery', code: 'SpecialLogistics' },
  { icon: 'feedback.png', name: i18n.t('问题反馈'), route: 'feedback', code: 'QuestionFeedBack', push: true },
  { icon: 'elearning.png', name: i18n.t('E-Learning'), route: 'elearning', code: 'Patterns', push: true }
]
